import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { careTeam, teamActivityInProcess } from "redux-store/care-team/care-team.selector";
import { getCareTeamWithUserId, getUserteams } from "redux-store/care-team/care-team.slice";
import { AppDispatch } from "redux-store/store";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CareTeamRowAdmin from "./CareTeamRowAdmin";
import Loader from "components/loader/Loader";
import { useNavigate } from "react-router-dom";

interface Props {
  userId: any;
  showVetModel: boolean;
  setShowVetModel: any;
  showButtons: boolean;
}
const CareTeamModel = ({ userId, showVetModel, setShowVetModel, showButtons }: Props) => {
  const teams = useSelector(careTeam);
  const loading = useSelector(teamActivityInProcess);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const handleClose = () => {
    setShowVetModel(false);
  };

  useEffect(() => {
    if (userId) {
      dispatch(getCareTeamWithUserId(userId));
    }
  }, [userId]);
  const handleAdd = () => {
    navigate(`/admin/add-care-team/${userId && userId}`);
  };

  return (
    <div>
      <Dialog
        open={showVetModel}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{}}
        fullWidth
      >
        <div className="tw-pt-4 tw-flex tw-justify-end tw-px-4">
          <button
            onClick={() => handleAdd()}
            className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[blue] tw-py-2 tw-px-8 tw-rounded-md"
          >
            Add Vet
          </button>
        </div>

        <DialogTitle id="alert-dialog-title">Vet info</DialogTitle>
        <DialogContent>
          <div className="tw-flex tw-flex-col tw-gap-3">
            {loading ? (
              <Loader />
            ) : teams?.length !== 0 && teams ? (
              teams.map((team, i) => (
                <CareTeamRowAdmin
                  key={team._id}
                  id={team._id}
                  hospitalName={team.hospitalName}
                  vetName={team.veterinarianName}
                  email={team.email}
                  phone={team.phone}
                  showButtons={showButtons}
                  userId={userId}
                />
              ))
            ) : (
              "No Team Found"
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CareTeamModel;
